// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-status-wrapper {
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 50px;
}
.payment-status-wrapper .booking-info-parent-wrapper-psp {
  display: flex;
  gap: 20px;
  width: 100%;
  max-width: 1440px;
  padding: 0px 18px;
}
.payment-status-wrapper .booking-info-parent-wrapper-psp > div {
  width: 50%;
}

@media only screen and (width <= 768px) {
  .payment-status-wrapper .booking-info-parent-wrapper-psp {
    flex-direction: column;
  }
  .payment-status-wrapper .booking-info-parent-wrapper-psp > div {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PaymentStatusPage/style.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AACJ;AACI;EACI,aAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;AACR;AACQ;EACI,UAAA;AACZ;;AAIA;EAEQ;IACI,sBAAA;EAFV;EAGU;IACI,WAAA;EADd;AACF","sourcesContent":[".payment-status-wrapper{\n    width: 100vw;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 50px;\n\n    .booking-info-parent-wrapper-psp{\n        display: flex;\n        gap: 20px;\n        width: 100%;\n        max-width: 1440px;\n        padding: 0px 18px;\n\n        >div{\n            width: 50%;\n        }\n    }\n}\n\n@media only screen and (width <= 768px) {\n    .payment-status-wrapper{   \n        .booking-info-parent-wrapper-psp{    \n            flex-direction: column;\n            >div{\n                width: 100%;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
